<template>
  <div class="pagemain">
    <div class="info_div">
      <div class="title_div2">
        <div class="title_icon"></div>
        个人信息
      </div>
      <div class="userbasic">
        <div>
          <div class="info_inner">
            <div class="name_field">用户头像：</div>
            <div>
              <img :src="bind_info.user_info.avatar" class="user_avatar" alt="" />
            </div>
          </div>
          <div class="info_inner">
            <div class="name_field">用户姓名：</div>
            <span class="name_field_txt">{{ bind_info.user_info.name }}</span>
          </div>
        </div>
        <div>
          <div class="info_inner">
            <div class="name_field">登录手机号：</div>
            <span class="name_field_txt">{{ bind_info.user_info.phone }}</span>
          </div>
          <div class="info_inner">
            <div class="name_field">用户所在部门：</div>
            <span class="name_field_txt">{{ bind_info.user_info.team_name }}</span>
            <span v-if="bind_info.user_info.dep_name" class="name_field_txt">/ {{ bind_info.user_info.dep_name }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="info_div">
      <div class="title_div2">
        <div class="title_icon"></div>
        微信二维码名片&nbsp;<span class="iconfont iconweixin1"></span>
      </div>
      <div class="wxqrcode_div">
        <div class="wxqrcode_img_div">
          <Spin fix v-if="wx_qrcode_loading" size="small"></Spin>
          <img v-if="wx_qrcode_img" :src="wx_qrcode_img" class="wxqrcode_img" alt="微信二维码名片" @click="preview_qrcode" />
          <div v-else class="wxqrcode_empty">暂无二维码名片</div>
        </div>
        <div class="wxqrcode_right">
          <div class="wxqrcode_tip">
            上传您的微信二维码名片，方便项目员工扫码添加您为微信好友。
          </div>
          <div class="wxqrcode_tip2">支持 jpg、png 格式，大小不超过 2MB。</div>
          <Upload :action="upload_wxqrcode_url" :show-upload-list="false" accept="image/jpeg,image/png,image/jpg"
            :before-upload="before_upload_wxqrcode" :on-success="wxqrcode_upload_success"
            :on-error="wxqrcode_upload_error">
            <Button type="primary" size="small" icon="ios-cloud-upload-outline">
              {{ wx_qrcode_img ? "更换二维码" : "上传二维码" }}
            </Button>
          </Upload>
        </div>
        <div class="wxqrcode_switch">
          <span class="wxqrcode_switch_label">是否对外保密手机号</span>
          <Switch v-model="is_phone_secret" size="small" :loading="hide_phone_loading" @on-change="change_hide_phone" />
        </div>
      </div>
    </div>

    <div class="info_div">
      <div class="title_div2">
        <div class="title_icon"></div>
        绑定微信&nbsp;<span class="iconfont iconweixin1"></span>
      </div>
      <div class="info_inner">
        <div class="name_field">绑定状态：</div>
        <span class="success_txt" @click="click_bind_wx" v-if="bind_info.bind_weixin_mp">已绑定（点击可换绑或重绑）</span>
        <span class="warning_txt" @click="click_bind_wx" v-else>未绑定无法收到微信通知，点击绑定</span>
      </div>
      <div class="info_inner">
        <div class="name_field">微信昵称:</div>

        <img v-if="bind_weixin_mp_data.avatar" :src="bind_weixin_mp_data.avatar" alt="" class="weixin_avatar" />
        <span class="weixin_nickname">{{
          bind_weixin_mp_data.name ? bind_weixin_mp_data.name : "--"
        }}</span>
      </div>
    </div>

    <div class="info_div">
      <div class="title_div2">
        <div class="title_icon"></div>
        绑定钉钉&nbsp;<span class="iconfont icondingding"></span>
      </div>
      <div class="info_inner">
        <div class="name_field">绑定状态·:</div>

        <span class="success_txt" @click="click_bind_dingding" v-if="bind_info.bind_dingding">已绑定（点击可换绑或重绑）</span>
        <span class="warning_txt" @click="click_bind_dingding" v-else>未绑定无法收到钉钉通知，点击绑定</span>
      </div>
      <div class="info_inner">
        <div class="name_field">钉钉昵称:</div>
        <span class="weixin_nickname">
          {{ bind_dingding_data.name ? bind_dingding_data.name : "--" }}</span>
      </div>
    </div>

    <Modal width="400" v-model="bind_wx_show" :mask-closable="false" title="绑定微信通知" :closable="true"
      @on-visible-change="bind_weixin_show_change" :footer-hide="true">
      <div class="bind_wx_status_title">
        您还没有绑定微信，微信通知将无法收到!！ <br />
        请使用微信扫一扫关注公众号绑定
        <br />
      </div>
      <div class="bing_qr_img_div">
        <Spin fix v-if="bind_wx_qr_loading"></Spin>
        <div class="bind_qr_img">
          <img :src="bind_wx_qr_img" alt="" class="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </Modal>

    <Modal width="400" v-model="bind_dingding_show" :mask-closable="false" title="绑定钉钉通知" :closable="true"
      @on-visible-change="bind_dingding_show_change" :footer-hide="true">
      <div class="bind_wx_status_title">
        您还没有绑定钉钉，钉钉通知将无法收到!！ <br />
        请使用钉钉APP扫一扫绑定
        <br />
      </div>
      <div class="bing_qr_img_div">
        <Spin fix v-if="bind_dingding_qr_loading"></Spin>
        <div class="bind_qr_img">
          <img :src="bind_dingding_qr_img" alt="" class="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { open_new_page, http } from "@/utils/http";

export default {
  name: "app_user_info",
  data() {
    return {
      //   user_info_data: {
      //     name: "",
      //     phone: "",
      //     avatar: "",
      //   },
      bind_info: {
        user_info: {
          name: "",
          phone: "",
          avatar: "",
          team_name: "",
          dep_name: "",
        },
        bind_dingding: false,
        bind_weixin_mp: false,
      },
      bind_weixin_mp_data: {},

      //   微信二维码名片
      wx_qrcode_img: "",
      wx_qrcode_loading: false,
      is_phone_secret: false,
      hide_phone_loading: false,
      upload_wxqrcode_url:
        process.env.VUE_APP_HOST +
        "/staff/user_index/upload_wxqrcode?token=" +
        this.$cookies.get("dx_token"),

      //   绑定微信弹窗
      bind_wx_show: false,
      bind_wx_qr_img: "",
      bind_wx_qr_loading: false,

      // 绑定钉钉弹窗
      bind_dingding_data: {},
      bind_dingding_show: false,
      bind_dingding_qr_img: "",
      bind_dingding_qr_loading: false,
    };
  },
  mounted() { },

  methods: {
    bind_dingding_show_change() {
      this.get_bind_info();
    },

    bind_weixin_show_change() {
      this.get_bind_info();
    },

    open() {
      this.get_bind_info();
      this.get_user_qrcode();
    },

    // 获取微信二维码名片
    get_user_qrcode() {
      var that = this;
      var obj = {};
      this.wx_qrcode_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/get_user_qrcode",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.wx_qrcode_img = res.data.img;
            that.is_phone_secret = res.data.hide_phone == 1;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.wx_qrcode_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.wx_qrcode_loading = false;
        });
    },

    // 切换是否对外保密手机号
    change_hide_phone(val) {
      var that = this;
      var obj = {
        hide_phone_status: val ? 1 : 0,
      };
      this.hide_phone_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/update_hide_phone",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success(res.msg);
          } else {
            that.$Message.error(res.msg);
            that.is_phone_secret = !val;
          }
          that.hide_phone_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.$Message.error("更新失败，请稍后重试");
          that.is_phone_secret = !val;
          that.hide_phone_loading = false;
        });
    },

    // 点击预览二维码
    preview_qrcode() {
      this.$ImagePreview.show({
        previewList: [this.wx_qrcode_img],
      });
    },

    // 上传前校验
    before_upload_wxqrcode(file) {
      var allow_type = ["image/jpeg", "image/png", "image/jpg"];
      if (allow_type.indexOf(file.type) == -1) {
        this.$Message.error("仅支持 jpg、png 格式的图片");
        return false;
      }
      // if (file.size > 1024 * 100) {
      //   this.$Message.error("图片大小不能超过 100KB");
      //   return false;
      // }
      return true;
    },

    // 上传成功
    wxqrcode_upload_success(res) {
      if (res.code == 0) {
        this.$Message.success(res.msg);
        this.wx_qrcode_img = res.data.url;
      } else {
        this.$Message.error(res.msg);
      }
    },

    // 上传失败
    wxqrcode_upload_error() {
      this.$Message.error("上传异常，请稍后重试");
    },

    //点击绑定微信
    click_bind_wx() {
      this.get_bind_wx_qr();
      this.bind_wx_show = true;
    },

    click_bind_dingding() {
      this.get_bind_dingding_qr();
      this.bind_dingding_show = true;
    },

    get_bind_dingding_qr() {
      var that = this;
      var obj = {};
      this.bind_dingding_qr_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/bind_dingding_qr",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(333, res);
          if (res.code == 0) {
            that.bind_dingding_qr_img = res.data.qr_b64;
            that.bind_dingding_qr_loading = false;
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
          that.bind_wx_qr_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_bind_wx_qr() {
      var that = this;
      var obj = {};
      this.bind_wx_qr_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/bind_wx_qr",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.bind_wx_qr_img = res.data.qr_b64;
            // that.show = true
            // that.$emit('change', 'open')
            // console.log('跳转用户中心')
            // that.$router.push({'path':'/user/index'})
          } else {
            that.$Message.info("请先登录哟~");
          }
          that.bind_wx_qr_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_bind_info() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/bind_platform_info",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.bind_info = res.data;
            that.bind_weixin_mp_data = res.data.bind_weixin_mp_data;
            that.bind_dingding_data = res.data.bind_dingding_data;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.send_msg_loading = false;
        });
    },
  },
};
</script>

<style scoped>
.iconweixin1 {
  font-size: 18px;
  color: #04ae3f;
  margin: 0 3px;
}

.icondingding {
  font-size: 18px;
  color: #318cfa;
}

.wxqrcode_div {
  display: flex;
  align-items: center;
  padding: 10px;
}

.wxqrcode_img_div {
  position: relative;
  width: 90px;
  height: 90px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
}

.wxqrcode_img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: zoom-in;
}

.wxqrcode_empty {
  font-size: 12px;
  color: #999;
}

.wxqrcode_right {
  margin-left: 20px;
}

.wxqrcode_tip {
  font-size: 13px;
  color: #555;
  margin-bottom: 6px;
}

.wxqrcode_tip2 {
  font-size: 12px;
  color: #999;
  margin-bottom: 12px;
}

.wxqrcode_switch {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.wxqrcode_switch_label {
  font-size: 13px;
  color: #555;
  margin-right: 8px;
}

.userbasic {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user_avatar {
  width: 40px;
  height: 40px;
  border-radius: 5px;
}

.bind_wx_status_title {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
}

.bing_qr_img_div {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  position: relative;
}

.bind_qr_img {
  width: 150px;
  height: 150px;
  border: 1px solid #989898;
}

.warning_txt {
  color: red;
  cursor: pointer;
  font-size: 13px;
}

.warning_txt:hover {
  color: red;
  font-weight: 600;
}

.name_field_txt {
  font-size: 13px;
}

.success_txt {
  color: #0466dd;
  cursor: pointer;
  font-size: 13px;
}

.weixin_avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 5px;
}

.success_txt:hover {
  font-weight: 600;
}

.name_field {
  width: 100px;
  flex-shrink: 0;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.weixin_nickname {
  color: #555555;
  font-size: 13px;
}

.info_inner {
  padding: 10px 10px 5px 10px;
  height: 40px;
  display: flex;
  align-items: center;
}

.title_div2 {
  display: flex;
  align-items: center;
  margin-left: 5px;
  margin-top: 5px;
  font-weight: 600;
  font-size: 14px;
  padding-bottom: 5px;
  margin-bottom: 4px;
  border-bottom: 1px solid #f5f5f5;
}

.title_icon {
  border-radius: 3px;
  margin-right: 10px;
  height: 15px;
  width: 8px;
  background: #0466dd;
}

.info_div {
  background: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.pagemain {
  width: calc(100vw - 120px);
  padding: 10px;
  background: #ececec;
  min-height: 100vh;
}
</style>
